/**
 * Price type enum matching backend PriceTypeDto values
 */
export enum PriceType {
  PER_ITEM = 'PER_ITEM',
  PER_KG = 'PER_KG',
  PER_HG = 'PER_HG',
  PER_GR = 'PER_GR',
  OPEN_PRICE = 'OPEN_PRICE',
}

/**
 * Validates and normalizes a price type string
 * @param priceType - The price type string to validate (may be undefined/null)
 * @returns A valid PriceType enum value, defaults to PER_ITEM if invalid
 */
export function normalizePriceType(priceType: string | undefined | null): PriceType {
  if (!priceType) {
    return PriceType.PER_ITEM;
  }

  const normalized = priceType.toUpperCase();

  if (Object.values(PriceType).includes(normalized as PriceType)) {
    return normalized as PriceType;
  }

  return PriceType.PER_ITEM;
}

/**
 * Check if a price type is weight-based (requires weight measurements in grams)
 * @param priceType - The price type to check
 * @returns true if the price type requires weight measurements
 */
export function isWeightBasedPriceType(priceType: string | undefined | null): boolean {
  const normalized = normalizePriceType(priceType);
  return [PriceType.PER_KG, PriceType.PER_HG, PriceType.PER_GR].includes(normalized);
}
